import { useState, useLayoutEffect } from "react";
import { DESKTOP_BREAKPOINT, isDesktopWidth } from "@/constants/breakpoint";

/**
 * 客户端视口是否为 PC 宽度（> 768px）。
 * SSR 与 hydration 首屏 width 为 null；useLayoutEffect 中同步读取 innerWidth（绘制前更新，避免明显闪烁）。
 */
export default function useIsDesktop() {
  // 首屏必须为 null，与 SSR 一致，避免 hydration mismatch；宽度在 useLayoutEffect 中同步读取
  const [width, setWidth] = useState(null);

  useLayoutEffect(() => {
    const update = () => setWidth(window.innerWidth);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return {
    width,
    isDesktop: isDesktopWidth(width),
    /** 尚未拿到视口宽度 */
    isReady: width != null,
  };
}

export { DESKTOP_BREAKPOINT };
